module.exports = __webpack_public_path__ + "img/trial-wizard.c4190fd1.png";